import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mapToSystemField: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.map-to-system-field',
		defaultMessage: 'MAP TO A SYSTEM FIELD',
		description: 'System field heading in the dropdown',
	},
	mapToCustomField: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.map-to-custom-field',
		defaultMessage: 'MAP TO AN EXISTING CUSTOM FIELD',
		description: 'Custom field heading in the dropdown',
	},
	mapToIssueLink: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.map-to-issue-link',
		defaultMessage: 'MAP TO A LINK TYPE',
		description: 'Issue links heading in dropdown',
	},
	createNewCustomField: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.create-new-custom-field',
		defaultMessage: 'CREATE A NEW CUSTOM FIELD',
		description: 'Custom a new custim filed dropdown item',
	},
	searchAllFieldsPlaceholder: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.search-all-fields-placeholder',
		defaultMessage: 'Search all fields',
		description: 'Search fields placeholder',
	},
	clearSelection: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.clear-selection',
		defaultMessage: 'Clear selection',
		description: 'Clear selected field',
	},
	disabledTooltip: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.disabled-tooltip',
		defaultMessage: 'This field is already mapped to another CSV field.',
		description: 'Disabled selected field tooltip',
	},
	noOptionsFound: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.no-options-found',
		defaultMessage: 'No options found',
		description: 'No fileds available with search term',
	},
});
